import VendorsList from "../../VendorsList/VendorsList"


const Vendors = () => {
  return (
    <div>
      <VendorsList/>
    </div>
  )
}

export default Vendors
